// API endpoint URL
// Change to whatever the non-localhost URL is
export const baseURL = "http://localhost:4000";